import * as React from 'react';
import { format } from 'date-fns';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import {
  Box,
  Button,
  CircularProgress,
  Grid2,
  useMediaQuery,
} from '@mui/material';
import { ServiceCategory } from '@prisma/client';
import Time from './Time';
import CustomTime from './CustomTime';
import useDayAvailabletimes from '../../../hooks/appointments/useDayAvailableTimes';
import { TakenSessionSlot } from '../../../types/appointments';

type Props = {
  selectedDay: Date;
  duration: string;
  employeeId: string;
  rescheduleAppointmentId?: string;
  timezone: string;
  onChange: (value: Date) => void;
  closeModal: any;
  setDayIsSelected: React.Dispatch<React.SetStateAction<boolean>>;
  serviceCategory?: ServiceCategory;
  takenSlots?: TakenSessionSlot[];
};

export default function TimeList({
  selectedDay,
  duration,
  employeeId,
  timezone,
  onChange,
  closeModal,
  setDayIsSelected,
  rescheduleAppointmentId,
  serviceCategory,
  takenSlots,
}: Props) {
  const isDesktop = useMediaQuery('(min-width:900px)');

  const {
    data: availableTimes,
    isFetching,
    isError,
  } = useDayAvailabletimes({
    day: selectedDay,
    employeeId,
    timezone,
    duration,
    rescheduleAppointmentId,
    serviceCategory,
    takenSlots,
  });

  const dayHeaderFormat = 'eeee, MMMM d';

  return (
    <Grid2
      size={{
        xs: 12,
        md: 4,
      }}
      className="time-box">
      <div>
        {!isDesktop && (
          <Button
            variant="text"
            className="text-btn"
            style={{
              position: 'absolute',
            }}
            onClick={() => setDayIsSelected(false)}>
            Back
          </Button>
        )}
        <Typography variant="body1">
          {format(selectedDay, dayHeaderFormat)}
        </Typography>
      </div>
      <Stack spacing={1.25} className="time-stack">
        {isFetching && (
          <Box display="flex" alignItems="center" justifyContent="center">
            <CircularProgress color="primary" size={24} />
          </Box>
        )}
        {isError && (
          <Typography variant="body2" className="error">
            Error loading times. Please try again
          </Typography>
        )}
        {availableTimes && availableTimes.length === 0 && !isFetching && (
          <Typography variant="body2">
            No available times on this day
          </Typography>
        )}
        {availableTimes &&
          !isFetching &&
          availableTimes.map(time => (
            <Time
              time={time}
              onChange={onChange}
              key={time.startDateTime}
              closeModal={closeModal}
            />
          ))}
        <CustomTime
          onChange={onChange}
          closeModal={closeModal}
          selectedDay={selectedDay}
        />
      </Stack>
    </Grid2>
  );
}
